import React from 'react'

/**
 * Data Context
 */
export const Context = React.createContext({})
